export default __webpack_public_path__ + "static/media/template8.7860283b.svg";